import React, { useState, createContext } from 'react';

export const ActionContext = createContext();
export const ActionDispatcherContext = createContext();

function ActionProvider({ children }) {
  const [state, setState] = useState([]);

  return (
    <ActionContext.Provider value={state}>
      <ActionDispatcherContext.Provider value={setState}>
        {children}
      </ActionDispatcherContext.Provider>
    </ActionContext.Provider>
  );
}

export { ActionProvider };
